import { ChangeEvent, FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import { TYPE_FILES_ALLOWED } from 'constants/defaultConstants';

import errorSwal from 'utils/errorSwal';
import { isDocumentFileAllowed } from 'utils/isDocumentFileAllowed';

type BoardDetailsDocumentsCardHeaderProps = {
  isAdmin: boolean;
  onChangeFiles: (files: File[]) => void; // eslint-disable-line
};

const BoardDetailsDocumentsCardHeader: FC<
  BoardDetailsDocumentsCardHeaderProps
> = ({ isAdmin, onChangeFiles }) => {
  const { t } = useTranslate();

  const handleChangeFiles = async (event: ChangeEvent<HTMLInputElement>) => {
    const fileList = event.target.files;
    const newFiles = fileList ? [...fileList] : [];

    if (newFiles.length === 0) return;

    const validationResults = await Promise.all(
      newFiles.map((file) => isDocumentFileAllowed(file))
    );

    if (validationResults.some((isValid) => !isValid)) {
      errorSwal(t('InvalidFile'));
      return;
    }
    onChangeFiles(newFiles);
  };

  return (
    <div className="nk-block-head d-flex justify-content-between align-items-center flex-wrap">
      <div className="nk-block-head-content">
        <h5 className="nk-block-title title mb-0">{t('Documents')}</h5>
      </div>

      {isAdmin && (
        <div className="form-group mb-0">
          <label
            htmlFor="custom-file"
            className="btn btn-sm btn-dim btn-primary mb-0"
          >
            <em className="icon ni ni-upload" />
            <span>{t('AddDocumentation')}</span>
          </label>

          <input
            type="file"
            id="custom-file"
            name="custom-file"
            style={{ display: 'none' }}
            accept={TYPE_FILES_ALLOWED}
            onChange={handleChangeFiles}
            multiple
          />
        </div>
      )}
    </div>
  );
};

export default BoardDetailsDocumentsCardHeader;
